//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomSidebarMenuItem from './CustomSidebarMenuItem.vue'
import SoftwareVersion from '../SoftwareVersion.vue'

export default ({
    components: {
        CustomSidebarMenuItem,
        SoftwareVersion
    },
    props: {
        // Sidebar collapsed status.
        sidebarCollapsed: {
            type: Boolean,
            default: false,
        },

        // Main sidebar color.
        sidebarColor: {
            type: String,
            default: "primary",
        },

        // Main sidebar theme : light, white, dark.
        sidebarTheme: {
            type: String,
            default: "light",
        },

    },
    data() {
        return {
            rootSubmenuKeys: ['sub1', 'sub2', 'sub4'],
            // sidebarCollapsedModel: this.sidebarCollapsed,
            menuItems: null,
            openKeys: ['sub1'],
            selectedKeys: []
        }
    },
    onLoad() {

    },
    mounted() {
        this.pageLoad();
        //this.reSekected();
    },
    methods: {
        pageLoad() {
            this.menuItems = [];

            // this.menuItems.push(this.getItem('客戶管理', '客戶管理', '/', 'home'));
            // this.menuItems.push(this.getItem('訂單管理', '訂單管理', '/order', 'home'));

            this.menuItems.push(this.getItem('功能清單', '功能清單', '/', 'home', [
                this.getItem('客戶清單', '客戶清單', '/member', null),
                this.getItem('訂單清單', '訂單清單', '/order', null),
                this.getItem('產品清單', '產品清單', '/product', null),
                this.getItem('生產記錄', '生產記錄', '/receipt', null),
            ]));

            if (['admin'].includes(this.$store.state.user.username)) {
                this.menuItems.push(this.getItem('管理工具', '管理工具', '/tools', 'home', [
                    this.getItem('管理員清單', '管理員清單', '/administrators', null),
                ]));
            }


            console.log('menu', this.menuItems)

        },
        reSekected() {
            const url = this.$route.path;
            this.openKeys = [];
            this.selectedKeys = [];

            //const menus = this.menuItems;
            this.menuItems.forEach(item => {
                if (item.children) {
                    item.children.forEach(children => {
                        if (children.href == url) {
                            this.openKeys.push(item.key);
                            this.selectedKeys.push(item.key)
                            this.selectedKeys.push(children.key)
                        }
                    })
                } else {
                    if (item.href == url) {
                        this.selectedKeys.push(item.key);
                    }
                }
            });
            console.log('url', url)
            console.log('openKeys', this.openKeys)
            console.log('selectedKeys', this.selectedKeys)
        },
        getItem(label, key, href, icon, children) {
            return {
                key,
                href,
                icon,
                children,
                label
            };
        },
        handleClick() {

        },
        onOpenChange(openKeys) {
            const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
            if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                this.openKeys = openKeys;
            } else {
                this.openKeys = latestOpenKey ? [latestOpenKey] : [];
            }
        },

    }
})

